import cn from 'classnames';
import type { CSSProperties, ReactNode, ToggleEventHandler } from 'react';
import { IconDropDown } from '@/assets/icons/IconDropdown';
import styles from './nativeshowmore.module.scss';

export interface NativeShowMoreProps {
    showText?: ReactNode;
    hideText?: ReactNode;
    color?: string;
    className?: string;
    summaryClassName?: string;
    arrowClassName?: string;
    activeToggleTextPosition?: 'top' | 'bottom';
    ariaLabel?: string;
    dataLinkname?: string;
    id: string;
    contentClassName?: string;
    labelClassName?: string;
    children?: ReactNode;
    defaultOpen?: boolean;
    onToggle?: ToggleEventHandler<HTMLDetailsElement>;
}

export function NativeShowMore({
    showText = 'Show',
    hideText = 'Hide',
    color,
    className,
    summaryClassName,
    arrowClassName,
    activeToggleTextPosition,
    ariaLabel,
    dataLinkname,
    id,
    contentClassName,
    labelClassName,
    children,
    defaultOpen = false,
    onToggle,
}: NativeShowMoreProps): React.JSX.Element {
    const linkName = dataLinkname ?? (typeof showText === 'string' ? `Toggle:${showText}` : undefined);
    const colorStyle = {
        ...(color ? { '--text-button-color': color } : {}),
    } as CSSProperties;

    return (
        <details
            className={cn(styles.wrapper, className, {
                [styles.textTop]: activeToggleTextPosition === 'top',
            })}
            style={colorStyle}
            open={defaultOpen || undefined}
            onToggle={onToggle}
            data-cy="atoms-more-info-wrapper"
        >
            <summary
                className={cn(styles.caret, summaryClassName)}
                aria-controls={id}
                aria-label={ariaLabel}
                data-linkname={linkName}
                data-cy="atoms-show-more-button-2-0"
            >
                <span className={cn(styles.contentShowWrapper, labelClassName)}>
                    <span className={styles.showLabel}>{showText}</span>
                    <span className={styles.hideLabel}>{hideText}</span>
                    <span className={cn(styles.dropdownIcon, arrowClassName)} aria-hidden="true">
                        <IconDropDown />
                    </span>
                </span>
            </summary>
            <div id={id} className={cn(styles.contentWrapper, contentClassName)} data-cy="atoms-show-more-content">
                {children}
            </div>
        </details>
    );
}
